import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '@/lib/api';

export function useContent() {
  const [content, setContent] = useState({});
  const location = useLocation();
  useEffect(() => {
    // refetch on route change + window focus so admin edits appear without a hard reload
    const refresh = () => api.get('/content').then(({ data }) => setContent(data || {})).catch(() => {});
    refresh();
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [location.pathname]);
  return content;
}

export default useContent;